import { FC } from 'react'

const InvoiceIcon: FC<{ text: string }> = ({ text }) => (
  <svg
    width={50 + text.length * 2}
    height="28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width={50 + text.length * 2}
      height="26"
      rx="6"
      fill="#fff"
    />

    <text
      x="50%"
      y="53%"
      dominantBaseline="middle"
      textAnchor="middle"
      fill="#FF6600"
      fontSize="11"
      fontFamily="Arial, sans-serif"
      fontWeight="bold"
    >
      {text}
    </text>
  </svg>
)

export default InvoiceIcon
